//const aStar = require('a-star')

import { aStar_typescript } from './astar'

export interface IPathOptions<T> {
  start: T
  isEnd: (node: T) => boolean
  neighbor: (node: T) => T[]
  distance: (a: T, b: T) => number
  heuristic: (node: T) => number
  hash?: (node: T) => string
  timeout?: number
}

export interface IPathResult<T> {
  status: 'success' | 'noPath' | 'timeout'
  path: T[]
}

export function findPath<T>(options: IPathOptions<T>): IPathResult<T> {
  // let pathResult = aStar(options)
  let pathResult = aStar_typescript(options) as any
  // console.log(pathResult)
  return pathResult
}
